import {MoveRatingCategories} from "./gameEnums";

const mateRegex = /mate (.+)/

//This method is a heuristic that translates evaldiffs into a more visually appealing score
// (i.e. lower eval diffs get higher weight, because 0 -> 1 should give more visual swing than 10 -> 11)
//This is to ensure, that graphs and bars still show differences at low eval diffs.
export const calculateVisualScore = (evalDiff) => {

    let score;
    //For now, a simple heuristic is to convert a mate to 100 - no of mate moves
    if (typeof (evalDiff) === "string") {
        const evalMatch = evalDiff.trim().match(mateRegex)
        if (!evalMatch) {
            console.error("Unable to extract mate from eval string - did you accidentally pass score as string?")
            return null
        }

        const blackLeading = evalMatch[1].includes("-")
        const mateMoves = parseInt(evalMatch[1])
        score = blackLeading ? -100 - mateMoves : 100 - mateMoves;
    } else {

        score = evalDiff
    }

    //We convert the score to a positive one, as we use logarithms further down. But we save if it was negative,
    //so we can convert it back at the end
    const multiplier = score < 0 ? -1 : 1;
    score *=multiplier;

    //now we convert to something that grows quickly with small numbers - a 5 point lead is not too dissimilar from a 20 point lead
    //for now we operate with 0 -> 100
    //from this point on the score is always positive, as we converted earlier
    let visualScore;
    if (score < 1) {
        visualScore = 20 * score;
    } else {
        //The min is to cap it at 100 - and remember score is minimum 1 in this else condition
        visualScore = Math.min(100, 20 + 15 * Math.log2(score))
    }

    return visualScore * multiplier;
}

export const rateMoves = (evalDiffs, turns) => {
    //visual scores already give a good idea of the "severity" of a move
    const visualScores = evalDiffs.map((diff) => calculateVisualScore(diff))
    let ratings = []

    //we always access the next element to get the delta. So loop stops one iteration earlier than usual
    for(let i = 0; i < visualScores.length - 1; i++) {
        let delta = visualScores[i] - visualScores[i + 1];

        //for black a negative delta is good - so we change sign, such that we can compare the delta as we would for white
        delta = turns[i] === "b" ? -1 * delta : delta;
        const moveRating = {color: turns[i]}

        //switch statements in javascript are stupid
        switch (true) {
            case delta > 50:
                moveRating.category = MoveRatingCategories.BLUNDER;
                break;
            case delta > 35:
                moveRating.category = MoveRatingCategories.MISTAKE;
                break;
            case delta > 20:
                moveRating.category = MoveRatingCategories.INACCURACY;
                break;
            case delta > 10:
                moveRating.category = MoveRatingCategories.ALRIGHT_MOVE;
                break;
            case delta > 5:
                moveRating.category = MoveRatingCategories.GOOD_MOVE;
                break;
            default:
                moveRating.category = MoveRatingCategories.BEST_MOVE;
                break;
        }

        ratings.push(moveRating)
    }

    return ratings;
}